import type { InsightsFilterParams } from '@/api/resources/insights'

export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  organisations: {
    all: ['organisations'] as const,
    detail: (organisationId: number) => ['organisations', organisationId] as const,
  },
  organisationUsers: {
    all: (organisationId: number) => ['organisations', organisationId, 'users'] as const,
    list: (organisationId: number, params?: { search?: string }) =>
      ['organisations', organisationId, 'users', params ?? {}] as const,
  },
  organisationProducts: {
    all: (organisationId: number) => ['organisations', organisationId, 'products'] as const,
    list: (organisationId: number, params?: { search?: string }) =>
      ['organisations', organisationId, 'products', params ?? {}] as const,
  },
  organisationOperators: {
    all: (organisationId: number) => ['organisations', organisationId, 'operators'] as const,
    list: (organisationId: number, params?: { search?: string }) =>
      ['organisations', organisationId, 'operators', params ?? {}] as const,
  },
  walletUsers: {
    all: (organisationId: number) => ['organisations', organisationId, 'wallet-users'] as const,
    list: (organisationId: number, params?: { search?: string }) =>
      ['organisations', organisationId, 'wallet-users', params ?? {}] as const,
  },
  locations: {
    all: ['locations'] as const,
    list: (params?: { search?: string; organisation_id?: number[] }) =>
      ['locations', 'list', params ?? {}] as const,
    detail: (locationId: number) => ['locations', locationId] as const,
  },
  machines: {
    all: ['machines'] as const,
    list: (params?: {
      page?: number
      search?: string
      status?: string
      organisation_id?: number[]
    }) => ['machines', 'list', params ?? {}] as const,
    detail: (machineCode: string) => ['machines', machineCode] as const,
    operators: (machineCode: string) => ['machines', machineCode, 'operators'] as const,
    attachableUsers: (machineCode: string) =>
      ['machines', machineCode, 'operators', 'attachable'] as const,
    slotProducts: (
      machineCode: string,
      slotId: number,
      params?: { page?: number; search?: string },
    ) => ['machines', machineCode, 'slots', slotId, 'selectable-products', params ?? {}] as const,
  },
  orders: {
    all: ['orders'] as const,
    list: (params?: {
      page?: number
      search?: string
      status?: string
      organisation_id?: number[]
    }) => ['orders', 'list', params ?? {}] as const,
    detail: (orderId: number) => ['orders', orderId] as const,
  },
  invoices: {
    all: ['invoices'] as const,
    list: (params?: { page?: number; organisation_id?: number[] }) =>
      ['invoices', 'list', params ?? {}] as const,
  },
  webshop: {
    products: (organisationId: number, params?: { page?: number; search?: string }) =>
      ['organisations', organisationId, 'webshop', 'products', params ?? {}] as const,
  },
  dashboard: {
    summary: (params?: { organisation_id?: number[] }) =>
      ['dashboard', 'summary', params ?? {}] as const,
  },
  insights: {
    machineTypes: (params?: { organisation_id?: number[] }) =>
      ['insights', 'machine-types', params ?? {}] as const,
    monthly: (params?: InsightsFilterParams) => ['insights', 'monthly', params ?? {}] as const,
    daily: (params?: InsightsFilterParams) => ['insights', 'daily', params ?? {}] as const,
    byProduct: (params?: InsightsFilterParams) => ['insights', 'by-product', params ?? {}] as const,
    byMachine: (params?: InsightsFilterParams) => ['insights', 'by-machine', params ?? {}] as const,
    hourly: (params?: InsightsFilterParams) => ['insights', 'hourly', params ?? {}] as const,
  },
  productRequests: {
    all: ['product-requests'] as const,
    machine: (machineCode: string) => ['product-requests', machineCode] as const,
  },
} as const
